import Paper from '@mui/material/Paper';

const ContentPanel = ({ children, maxWidth, sx = {}, elevation = 0, ...rest }) => {
  return (
    <Paper
      elevation={elevation}
      sx={{
        width: '100%',
        maxWidth: maxWidth ?? '100%',
        bgcolor: 'background.paper',
        borderRadius: '20px',
        border: '1px solid #e5e7eb',
        p: '20px',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
};

export default ContentPanel;
